import { render } from "./MobileWallet.vue?vue&type=template&id=370b1616"
import script from "./MobileWallet.vue?vue&type=script&lang=js"
export * from "./MobileWallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__